import { getCrawlerUaPolicy } from './get-crawler-ua-policy';

export function isBotUserAgent(userAgent: string | null | undefined): boolean {
  return getCrawlerUaPolicy(userAgent) !== null;
}
